module.exports = __webpack_public_path__ + "static/media/Phera.03c2984e.gif";